.inline-spinner {
  position: relative;

  .spinner {
    position: absolute;
    top: 5px;
    left: 0;
  }

  .label {
    padding: 0 0 0 22px;
  }

  .loading-full {
    .spinner {
      margin: 0 0 0 -15px;
    }
  }
}
